import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import * as subscriptionActions from '../../store/subscriptions/actions';
import { actualUser } from '../../selectors/user';
import { actualSubscription } from '../../selectors/subscription';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import UserInfo from './UserInfo';
import SubscriptionInfo from '../../components/Subscriptions/SubscriptionInfo';
import SubscriptionDelete from '../../components/Subscriptions/SubscriptionDelete';
import InvoiceTable from '../../components/Invoices/InvoiceTable';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

const Settings = (props) => {
  const admin = useSelector((state) => state.Auth.admin);
  const subscription = useSelector(actualSubscription);
  const user = useSelector(actualUser);

  const [activeTab, setActiveTab] = useState('1');

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(subscriptionActions.fetchSubscriptionsByUser(user?.id));
  }, []);

  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Settings" size="8" />
          <div className="checkout-tabs">
            <Row>
              <Col lg="2" sm="3">
                <Nav className="flex-column" pills>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '1' })}
                      onClick={() => {
                        setActiveTab('1');
                      }}>
                      <i className="mdi mdi-account-circle d-block check-nav-icon mt-4 mb-2" />
                      <p className="fw-bold mb-4">Account</p>
                    </NavLink>
                  </NavItem>
                  {subscription && (
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '2' })}
                        onClick={() => {
                          setActiveTab('2');
                        }}>
                        <i className="bx bxs-credit-card d-block check-nav-icon mt-4 mb-2" />
                        <p className="fw-bold mb-4">Abbonamento</p>
                      </NavLink>
                    </NavItem>
                  )}
                  {user && subscription && (
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '3' })}
                        onClick={() => {
                          setActiveTab('3');
                        }}>
                        <i className="bx bxs-file-export d-block check-nav-icon mt-4 mb-2" />
                        <p className="fw-bold mb-4">Fatture</p>
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>
              </Col>
              <Col lg="10" sm="9">
                <Card>
                  <CardBody>
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="1">
                        <h4 className="card-title text-primary font-size-20 mb-4">
                          <i className="bx bx-user-circle mr-2"></i>Informazioni
                          personali
                        </h4>
                        <UserInfo admin={admin} />
                      </TabPane>
                      {subscription && (
                        <TabPane tabId="2">
                          <h4 className="card-title text-primary font-size-20 mb-4">
                            <i className="bx bx-purchase-tag mr-2"></i>
                            Il tuo abbonamento
                          </h4>
                          <SubscriptionInfo subscription={subscription} />
                          <hr className="my-4" />
                          <SubscriptionDelete subscription={subscription} />
                        </TabPane>
                      )}
                      {user && subscription && (
                        <TabPane tabId="3">
                          <h4 className="card-title text-primary font-size-20 mb-4">
                            <i className="bx bx-file mr-2"></i>Fatture
                          </h4>
                          <InvoiceTable />
                        </TabPane>
                      )}
                    </TabContent>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Settings;
